export class LesionConfig {
  private static _values: LesionConfig[] = [];
  private static _lookup: Map<number, LesionConfig> = new Map();

  static fromId(id: number) {
    const instance = LesionConfig._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid LesionConfig.id: ' + id);
    }
    return instance;
  }

  static values(): LesionConfig[] {
    return [...LesionConfig._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    LesionConfig._values.push(this);
    LesionConfig._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<LesionConfig: ' + this.id + ", label='" + this.label + "'>";
  }
}
